/* eslint-disable react/jsx-props-no-spreading */
import React, { Component } from 'react';
import {
  Modal,
  Dropdown,
  Icon,
  Popup,
  Label,
  Loader,
  Message,
} from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import cx from 'classnames';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import Update from 'immutability-helper';
import JSZip from 'jszip';
import ClarLoader from '../Loader/Loader';
import api from '../../api';
import closeBtn from '../../images/components/new_scan/close-btn.svg';
import progress from '../../images/icons/progress_ica.gif';
import search from '../../images/components/left_menu/searchIcon.png';
import foldImg from '../../images/components/left_menu/foldIcon.png';
import expandImg from '../../images/components/left_menu/expandIcon.png';
import bulletImg from '../../images/components/left_menu/bullet.png';
import CreateProjectModal from '../Modal/CreateProjectModal';
import AddVersionModal from '../Modal/AddVersionModal';
import ScanningFile from './ScanningFile';
import { convertPropertiesToCamelCase } from '../../utils/shared';
import WithRouter from '../Extensions/WithRouter';
import ScanOptionModal from '../Modal/ScanOptionModal';
import TextWithEllipsis from '../Extensions/TextWithEllipsis';
import './NewScanModal.css';

const ONE_DAY = 24 * 60 * 60 * 1000; // hr * min * sec * ms
const WAIT = ONE_DAY;
const MAX_FOLDER_SIZE = 50 * 1024 * 1024 * 1024; // 50GB

class NewScanModal extends Component {
  constructor(props) {
    super(props);
    this.updateInterval = null;
    this.updateTokenInterval = null;
    this.modalBody = null;
    this.dropzoneMsg = null;
    this.smallBody = null;
    this.cancelToken = [];
    this.fileInputRef = React.createRef();
    this.folderInputRef = React.createRef();
    this.state = {
      isOpenScan: props.isOpenScan,
      isOpenMCP: false,
      isOpenMAV: false,
      isOpenWarnDisk: false,
      isLoading: false,
      isLoadingTree: false,
      isOpenWarnModal: false,
      isStartScan: false,
      isShowURL: false,
      isUseScanOption: false,
      isOpenScanOption: false,
      isLoadingScanOptionBtn: false,
      modalWithError: false,
      isAllowShowQuota: false,
      licenseRegistered: false,
      licenseCurrent: false,
      errSearch: false,
      isUploadError: false,
      isUrlLoading: false,
      isWarnModalLoader: false,
      isWarModalError: false,
      uploadErrorMsg: '',
      quotaResult: [],
      activeIndex: [],
      projectList: [],
      scanOptions: {},
      scanOptionsWithGUI: {},
      scanningStatus: [],
      selectedIndex: '',
      selectedProject: '',
      selectedProjectNm: '',
      selectedVersion: '',
      selectedVersionNm: '',
      selectedColumn: 'uploaded',
      searchKeyword: '',
      targetName: '',
      targetId: '',
      usertimeStamp: localStorage.getItem('modal-timestamp'),
      parentId: '',
      isDroppable: true,
      fileURL: '',
      refreshInterval: 1000 * 60 * 5,
    };
  }

  componentDidMount() {
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      licenseRegistered, licenseCurrent, warnLevel, isLoading, scanningStatus
    } = this.state;
    const { state, isOpenScan } = this.props;
    if ((prevState.isLoading !== isLoading) && !isLoading) {
      if (!licenseRegistered || !licenseCurrent || warnLevel === 'forbidden') {
        return;
      }
      this.getProjectTree('findSelectedRow');
    }

    if ((prevState.scanningStatus.length !== scanningStatus.length) && scanningStatus.length === 0) {
      this.onUpdateStop();
      this.onUpdateTokenStop();
      state.report.setScanningCount(0);
      state.report.initScanningData();
    }

    if (prevProps.isOpenScan !== isOpenScan) {
      if (!isOpenScan) {
        this.onUpdateStop();
        this.onUpdateTokenStop();
      }
    }
    if (prevProps.isOpenScan !== isOpenScan) {
      state.report.syncNewScanModal(isOpenScan);
      state.report.initScanningData();
      this.modalBody = null;
      this.smallBody = null;
      this.dropzoneMsg = null;
      this.updateTokenInterval = null;
      this.setState({
        isOpenScan,
        searchKeyword: '',
        selectedColumn: 'uploaded',
        isDroppable: true,
        scanningStatus: [],
        isStartScan: false,
        isLoadingTree: false,
        isUseScanOption: false,
        selectedIndex: '',
        selectedProject: '',
        selectedProjectNm: '',
        selectedVersion: '',
        selectedVersionNm: '',
        isShowURL: false,
        fileURL: '',
        isUploadError: false,
        isOpenWarnModal: false,
        uploadErrorMsg: '',
        isOpenScanOption: false,
        isLoadingScanOptionBtn: false,
        projectList: [],
        activeIndex: [],
        scanOptions: {},
        scanOptionsWithGUI: {},
        isUrlLoading: false,
        isWarnModalLoader: false,
        isWarModalError: false,
        modalWithError: false,
      }, () => {
        if (isOpenScan) {
          this.getScanList();
        }
      });
    }
  }

  handleAddCallback = (res) => {
    const { projectList, targetId } = this.state;
    const findSelectedIndex = projectList.findIndex((item) => {
      return item.data.id === targetId;
    });

    this.setState({
      isOpenMAV: false,
      selectedVersion: res.id,
      selectedVersionNm: res.name,
    }, () => {
      this.getProjectVersionTree(findSelectedIndex, 'addVersion');
    });
  };

  handleSortingChange = (e, data) => {
    const { selectedColumn } = this.state;
    if (data.value === selectedColumn) {
      return;
    }
    this.setState(
      {
        selectedColumn: data.value,
        projectList: [],
        activeIndex: [],
        selectedIndex: [],
      },
      () => {
        this.getProjectTree();
      }
    );
  };

  handleToggle = (e, index) => {
    const { translate } = this.props;
    const {
      selectedIndex, projectList, licenseRegistered, licenseCurrent, isStartScan
    } = this.state;

    if (e.target.tagName === 'IMG' && (e.target.classList.contains('fold_icon') || e.target.classList.contains('expand_icon'))) {
      return null;
    }

    if (selectedIndex === index) {
      this.dropzoneMsg = translate('modal.new_scan.message.warn_project_verion');
      this.setState({
        selectedIndex: '',
        selectedProject: '',
        selectedProjectNm: '',
        selectedVersion: '',
        selectedVersionNm: '',
        isDroppable: false,
      });
      return null;
    }

    if (typeof index === 'string') {
      const stringValue = index.split('-');
      if (licenseRegistered && licenseCurrent && isStartScan) {
        this.setState({
          selectedIndex: index,
          selectedProject: projectList[Number(stringValue[0])].data.target_id.project_id,
          selectedProjectNm: projectList[Number(stringValue[0])].data.name,
          selectedVersion: projectList[Number(stringValue[0])].children[Number(stringValue[1])].data.target_id.project_version_id,
          selectedVersionNm: projectList[Number(stringValue[0])].children[Number(stringValue[1])].data.name,
          isDroppable: true,
        });
      } else {
        this.setState({
          selectedIndex: index,
          selectedProject: projectList[Number(stringValue[0])].data.target_id.project_id,
          selectedProjectNm: projectList[Number(stringValue[0])].data.name,
          selectedVersion: projectList[Number(stringValue[0])].children[Number(stringValue[1])].data.target_id.project_version_id,
          selectedVersionNm: projectList[Number(stringValue[0])].children[Number(stringValue[1])].data.name,
        });
      }
    }
  };

  handleMCPClose = () => {
    this.setState({
      isOpenMCP: false,
    });
  };

  handleMAVClose = () => {
    this.setState({
      isOpenMAV: false,
    });
  };

  handleCreateCallback = (res) => {
    this.setState({
      isOpenMCP: false,
      selectedProject: res.id,
      selectedProjectNm: res.name,
      projectList: [],
    }, () => {
      this.getProjectTree('createProject');
    });
  };

  onUpdateStart = () => {
    this.updateInterval = null;
    if (!this.onUpdateRunning()) {
      this.updateInterval = setInterval(() => {
        this.onUpdateCheck();
      }, 10000);
    }
  };

  onUpdateStop = () => {
    clearInterval(this.updateInterval);
    this.updateInterval = null;
  };

  onUpdateRunning = () => {
    return this.updateInterval !== null;
  };

  onUpdateTokenStart = () => {
    const { refreshInterval } = this.state;
    this.updateTokenInterval = null;
    if (!this.onUpdateTokenRunning()) {
      this.updateTokenInterval = setInterval(() => {
        this.getExtendToken();
      }, refreshInterval);
    }
  };

  onUpdateTokenStop = () => {
    clearInterval(this.updateTokenInterval);
    this.updateTokenInterval = null;
  };

  onUpdateTokenRunning = () => {
    return this.updateTokenInterval !== null;
  };

  onUpdateActiveProject = (string, project, projectVersion) => {
    const { scanningStatus } = this.state;
    if (scanningStatus.length === 0) {
      return;
    }

    if (string === 'project') {
      const activeProjectArray = scanningStatus.filter((item) => {
        return item.project_id === project.data.target_id.project_id;
      });

      if (activeProjectArray.length !== 0) {
        return (
          <p style={{ margin: '0' }}>
            <img
              src={progress}
              role="presentation"
              alt=""
              style={{
                width: 15,
                height: 15,
                margin: '3.2px 0 0 5px',
                verticalAlign: 'middle',
              }}
            />
          </p>
        );
      }
    }

    if (string === 'version') {
      const activeProjectVersionArray = scanningStatus.filter((item) => {
        return item.project_id === project.data.target_id.project_id && item.project_version_id === projectVersion.data.target_id.project_version_id;
      });

      if (activeProjectVersionArray.length !== 0) {
        return (
          <p style={{ margin: '0' }}>
            <img
              src={progress}
              role="presentation"
              alt=""
              style={{
                width: 15,
                height: 15,
                margin: '3.2px 0 0 5px',
                verticalAlign: 'middle',
              }}
            />
          </p>
        );
      }
    }
  };

  onDrop = (files) => {
    const { state } = this.props;
    this.onUpdateStop();
    const {
      uploadingProgressArray
    } = state.report;
    const {
      scanOptions,
      selectedProject,
      selectedVersion,
      selectedProjectNm,
      selectedVersionNm
    } = this.state;
    const customIds = [];
    const sliced = uploadingProgressArray.slice();

    if (!this.validateForm()) {
      return null;
    }

    const existIds = sliced.map((item) => {
      return item.frontId;
    });

    if (existIds.length === 0) {
      while (customIds.length < files.length) {
        const r = uuidv4();
        customIds.push(r);
      }
    } else {
      while (customIds.length < files.length) {
        const r = uuidv4();
        if (existIds.indexOf(r) === -1) {
          customIds.push(r);
        }
      }
    }

    const fileData = files.map((file, index) => {
      const formData = new FormData();
      formData.append('input_package', file);
      formData.append('selected_project_id', selectedProject);
      formData.append('selected_project_version_id', selectedVersion);
      formData.append('front_id', customIds[index]);
      if (Object.keys(scanOptions).length !== 0) {
        formData.append('scan_option', JSON.stringify(scanOptions));
      }
      formData.append('type', 'file');

      const newData = {
        project_id: selectedProject,
        project_version_id: selectedVersion,
        name: file.name,
        project_name: selectedProjectNm,
        project_version_name: selectedVersionNm,
        scan_status: 5,
        scan_status_detail: 'Uploading',
        scan_progress: 0,
        uploaded_size: this.byteToSize(file.size),
        has_manage_permission: true,
        front_id: customIds[index],
        type: 'local',
      };

      const obj = {
        front_id: customIds[index],
        status: 'upload',
      };

      state.report.updateProgressArray(1, newData.front_id, 'local');
      state.report.setScanning(obj);

      const newfiles = {
        formData,
        newData,
      };

      return newfiles;
    });

    this.setState((prevState) => {
      return {
        scanningStatus: [
          ...prevState.scanningStatus,
          ...fileData.map((file) => { return file.newData; }),
        ]
      };
    }, () => {
      this.postReport(fileData);
    });
  };

  onDropWithUrl = (url) => {
    const {
      selectedProject,
      selectedVersion,
      selectedProjectNm,
      selectedVersionNm,
      scanningStatus
    } = this.state;
    const { state } = this.props;
    this.onUpdateStop();
    const frontId = uuidv4();
    const newData = {
      project_id: selectedProject,
      project_version_id: selectedVersion,
      name: url.substring(url.lastIndexOf('/') + 1, url.length),
      project_name: selectedProjectNm,
      project_version_name: selectedVersionNm,
      scan_status: 6, //this status front only
      scan_status_detail: 'Uploading',
      scan_progress: 0,
      uploaded_size: '',
      has_manage_permission: true,
      front_id: frontId,
    };

    const fileArray = [...scanningStatus, newData];

    const obj = {
      front_id: frontId,
      status: 'upload',
    };

    state.report.updateProgressArray(1, newData.front_id, 'url');
    state.report.setScanning(obj);

    this.setState({
      scanningStatus: fileArray,
    }, () => {
      this.postReportWithUrl(newData, url);
    });
  };

  onDropFolder = async (folders, otherType) => {
    if ((otherType && Object.keys(folders).length === 0) || (folders.length === 0)) return;

    const {
      selectedProject,
      selectedVersion,
      selectedProjectNm,
      selectedVersionNm,
      scanningStatus,
      scanOptions,
    } = this.state;
    const { state, translate } = this.props;
    const { uploadingProgressArray } = state.report;

    let fileArray = [];
    const oversizedFolders = [];

    const getTotalFolderSize = (folderFiles) => {
      return Array.from(folderFiles).reduce((acc, file) => { return acc + file.size; }, 0);
    };

    if (otherType) {
      const customIds = [];
      const sliced = uploadingProgressArray.slice();
      const existIds = sliced.map((item) => { return item.frontId; });

      while (customIds.length < Object.keys(folders).length) {
        const r = uuidv4();
        if (!existIds.includes(r)) customIds.push(r);
      }

      const folderData = Object.keys(folders).map((folder, index) => {
        const folderSize = getTotalFolderSize(folders[folder]);

        if (folderSize > MAX_FOLDER_SIZE) {
          oversizedFolders.push(folder);
          return null;
        }

        const topFolderName = folder;
        const newData = {
          project_id: selectedProject,
          project_version_id: selectedVersion,
          name: topFolderName,
          project_name: selectedProjectNm,
          project_version_name: selectedVersionNm,
          scan_status: 7, // Compressing
          scan_status_detail: 'Compressing',
          scan_progress: 0,
          uploaded_size: '',
          has_manage_permission: true,
          front_id: customIds[index],
          type: 'local',
        };

        fileArray.push(newData);

        const obj = {
          front_id: customIds[index],
          status: 'compressing',
        };

        state.report.updateProgressArray(1, newData.front_id, 'folder');
        state.report.setScanning(obj);

        return {
          newData,
          folderData: Array.from(folders[folder]),
        };
      }).filter(Boolean);

      if (oversizedFolders.length > 0) {
        this.modalBody = translate('modal.message.folder_size_exceeded', { folders: oversizedFolders.join(', ') });
        this.setState({
          modalWithError: true,
        });
      }

      if (folderData.length === 0) return;

      this.setState((prevState) => {
        return {
          scanningStatus: [...prevState.scanningStatus, ...fileArray]
        };
      });

      const reportData = [];

      const promises = folderData.map(async (entity) => {
        const blobObj = await this.addToFolderToZip(entity.folderData, entity.newData);

        const updatedData = {
          ...entity.newData,
          scan_status: 5,
          scan_status_detail: 'Uploading',
          uploaded_size: this.byteToSize(blobObj.size),
        };

        const formData = new FormData();
        formData.append('input_package', blobObj.namedBlob);
        formData.append('selected_project_id', selectedProject);
        formData.append('selected_project_version_id', selectedVersion);
        formData.append('front_id', entity.newData.front_id);
        if (Object.keys(scanOptions).length !== 0) {
          formData.append('scan_option', JSON.stringify(scanOptions));
        }
        formData.append('type', 'folder');

        reportData.push({
          formData,
          newData: updatedData,
        });

        this.setState((prevState) => {
          return {
            scanningStatus: prevState.scanningStatus.map((item) => { return (item.front_id === entity.newData.front_id ? updatedData : item); })
          };
        });
      });

      await Promise.all(promises);
      this.postReport(reportData);

    } else {
      const frontId = uuidv4();
      const [topFolderName] = folders[0].webkitRelativePath.split('/');

      const totalSize = getTotalFolderSize(folders);

      if (totalSize > MAX_FOLDER_SIZE) {
        this.modalBody = translate('modal.message.folder_exceeds_limit', { folderName: topFolderName });
        return this.setState({
          modalWithError: true,
        });
      }

      const newData = {
        project_id: selectedProject,
        project_version_id: selectedVersion,
        name: topFolderName,
        project_name: selectedProjectNm,
        project_version_name: selectedVersionNm,
        scan_status: 7, // Compressing 상태
        scan_status_detail: 'Compressing',
        scan_progress: 0,
        uploaded_size: '',
        has_manage_permission: true,
        front_id: frontId,
        type: 'local',
      };

      fileArray = [...scanningStatus, newData];

      state.report.updateProgressArray(1, newData.front_id, 'folder');
      state.report.setScanning({
        front_id: frontId,
        status: 'compressing',
      });

      this.setState({ scanningStatus: fileArray });

      const blobObj = await this.addToFolderToZip(Array.from(folders), newData);

      const updatedData = {
        ...newData,
        scan_status: 5,
        scan_status_detail: 'Uploading',
        uploaded_size: this.byteToSize(blobObj.size),
      };

      const formData = new FormData();
      formData.append('input_package', blobObj.namedBlob);
      formData.append('selected_project_id', selectedProject);
      formData.append('selected_project_version_id', selectedVersion);
      formData.append('front_id', frontId);
      if (Object.keys(scanOptions).length !== 0) {
        formData.append('scan_option', JSON.stringify(scanOptions));
      }
      formData.append('type', 'folder');

      this.setState((prevState) => {
        return {
          scanningStatus: prevState.scanningStatus.map((item) => { return (item.front_id === frontId ? updatedData : item); })
        };
      }, () => {
        this.postReport([{ formData, newData: updatedData }]);
      });
    }
  };

  onUpdateCheck = () => {
    const { state } = this.props;
    const { scanningData } = state.report;
    const { scanningStatus, isAllowShowQuota, quotaResult } = this.state;
    const storeScanningData = scanningData.slice();
    const cloneScanningStatus = [...scanningStatus];
    let scanningIds = [];

    //scanningArray
    //scanning
    //queue
    //uploading url
    //preparing url upload

    if (cloneScanningStatus.length === 0) {
      return this.onUpdateTokenStop();
    }

    scanningIds = storeScanningData.map((item) => {
      return item.front_id;
    });

    const obj = {
      page: 1,
      limit: '',
      front_ids: scanningIds,
    };

    api
      .getNewScanUpdateCheck(obj)
      .then((response) => {
        const data = convertPropertiesToCamelCase(response.data.response);
        if (!this.validateQuota(data)) {
          return;
        }

        let newState;
        let updatedResponse;
        let i = 0;

        scanningIds.map((frontId) => {
          const updatedResponseIndex = data.scanningStatus.findIndex((item) => {
            return item.front_id === frontId;
          });

          if (updatedResponseIndex === -1) {
            //scanning status === 6 ? check front_id in data.scanningStatus
            //file.type && file.scan_status === 5 && //uploading progress update with local
            const uploadingLocalStatusArray = cloneScanningStatus.filter((item) => {
              return item.type && item.scan_status === 5;
            });
            const uploadingUrlStatusArray = cloneScanningStatus.filter((item) => {
              return item.scan_status === 6;
            });

            if (uploadingLocalStatusArray.length !== 0) {
              return false; //local uploading
            }
            if (uploadingUrlStatusArray.length !== 0) {
              return false; //url prepare uploading
            }

            const currentIndex = cloneScanningStatus.findIndex((item) => {
              return item.front_id === frontId;
            });

            if (currentIndex === -1) {
              return console.log('Invalid case');
            }

            //scan complete
            const storeObject = {
              front_id: frontId,
              status: 'complete',
            };
            state.report.removeScanning(storeObject);

            //remove scanning row
            newState = cloneScanningStatus.filter((item) => {
              return item.front_id !== frontId;
            });

            return this.setState({
              scanningStatus: newState,
            });
          }

          const updatedStateIndex = cloneScanningStatus.findIndex((item) => {
            return item.front_id === frontId;
          });

          if (updatedStateIndex === -1) {
            const storeObject = {
              front_id: frontId,
              status: 'Invalid',
            };
            state.report.removeScanning(storeObject);
            return console.log('Invalid state case');
          }

          if (
            (data.scanningStatus[updatedResponseIndex].scan_status !== cloneScanningStatus[updatedStateIndex].scan_status) //scan_status
            || (data.scanningStatus[updatedResponseIndex].uploaded_progress !== cloneScanningStatus[updatedStateIndex].uploaded_progress) //uploaded_progress
            || (data.scanningStatus[updatedResponseIndex].scan_progress !== cloneScanningStatus[updatedStateIndex].scan_progress) //scan_progrss
            || (data.scanningStatus[updatedResponseIndex].scan_status_detail !== cloneScanningStatus[updatedStateIndex].scan_status_detail) // scan_status_detail
          ) {
            if (i === 0) {
              updatedResponse = Update(cloneScanningStatus[updatedStateIndex], { $set: data.scanningStatus[updatedResponseIndex] });
              newState = Update(cloneScanningStatus, {
                $splice: [[updatedStateIndex, 1, updatedResponse]],
              });
              i++;
            } else {
              updatedResponse = Update(newState[updatedStateIndex], { $set: data.scanningStatus[updatedResponseIndex] });
              newState = Update(newState, {
                $splice: [[updatedStateIndex, 1, updatedResponse]],
              });
              i++;
            }
            //value {front_id, status} // status: 'upload', 'scanning', 'complete'

            if (data.scanningStatus[updatedResponseIndex].scan_status === 0
              || data.scanningStatus[updatedResponseIndex].scan_status === 1) {
              const storeObject = {
                front_id: frontId,
                status: 'scanning',
              };
              state.report.setScanning(storeObject);
            }

            if (data.scanningStatus[updatedResponseIndex].scan_status === 5) {
              const storeObject = {
                front_id: frontId,
                status: 'upload',
              };
              state.report.setScanning(storeObject);
            }
            return this.setState({
              scanningStatus: newState,
            });
          }
          return newState;
        });

        state.report.setScanningCount(scanningStatus.length);

        if (isAllowShowQuota !== data.quota.allow_show_quota) {
          this.setState({
            isAllowShowQuota: data.quota.allow_show_quota,
          });
        }

        if (quotaResult[0].spent !== data.quota.quota_result[0].spent
          || quotaResult[0].capacity !== data.quota.quota_result[0].capacity
          || quotaResult[0].type !== data.quota.quota_result[0].type) {
          this.setState({
            quotaResult: data.quota.quota_result,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          isLoading: false,
          isLoadingTree: false,
        });
      });
  };

  handleSearch = (event) => {
    if (event.key === 'Enter') {
      if (event.target.value === '' || event.target.value.length < 2) {
        this.setState(
          {
            errSearch: true,
          },
          () => {
            setTimeout(() => {
              this.setState({
                errSearch: false,
              });
            }, 1500);
          }
        );
        return false;
      }
      this.setState(
        {
          searchKeyword: event.target.value,
          projectList: [],
          activeIndex: [],
          selectedIndex: [],
        },
        () => {
          this.getProjectTree('search');
        }
      );
    }
  };

  getProjectTree = (callback) => {
    const { translate } = this.props;
    const {
      licenseRegistered,
      licenseCurrent,
      searchKeyword,
      selectedColumn,
      selectedProject,
    } = this.state;
    if (callback === 'createProject') {
      this.setState({
        isLoadingTree: true,
      }, () => {
        api.getProjectVersionTree(
          {
            search: '',
            target_object: 'project',
            page: 1,
            order: selectedColumn,
          }
        )
          .then((response) => {
            const projectList = response.response.map((item) => {
              return {
                data: item,
                children: [],
              };
            });
            const findSelectedIndex = projectList.findIndex((item) => {
              return item.data.id === selectedProject;
            });
            this.search.value = '';

            if (findSelectedIndex === -1) {
              console.log('cannot find project list');
              return this.setState({
                isLoadingTree: false,
                searchKeyword: '',
                projectList,
              });
            }

            if (licenseRegistered && licenseCurrent) {
              this.setState({
                isLoadingTree: false,
                isDroppable: true,
                projectList,
                searchKeyword: '',
              }, () => {
                this.findSelectedRow({ projectIndex: findSelectedIndex, target: callback });
              });
            } else {
              this.setState({
                isLoadingTree: false,
                searchKeyword: '',
                projectList,
              }, () => {
                this.findSelectedRow({ projectIndex: findSelectedIndex, target: callback });
              });
            }
          })
          .catch((err) => {
            console.log(err);
            this.setState({
              isLoadingTree: false,
            });
          });
      });
    } else {
      this.setState({
        isLoadingTree: true,
      }, () => {
        api.getProjectVersionTree(
          {
            search: searchKeyword,
            target_object: 'project',
            page: 1,
            order: selectedColumn,
          }
        )
          .then((response) => {
            const projectList = response.response.map((item) => {
              return {
                data: item,
                children: [],
              };
            });

            if (callback === 'findSelectedRow') {
              const findSelectedIndex = projectList.findIndex((item) => {
                return item.data.selected === true;
              });

              if (findSelectedIndex === -1) {
                this.dropzoneMsg = translate('modal.new_scan.message.warn_project_verion');
                if (projectList.length === 0) {
                  return this.setState({
                    isLoadingTree: false,
                    projectList,
                    isDroppable: false,
                  }, () => {
                    this.createProject();
                  });
                }

                return this.setState({
                  isLoadingTree: false,
                  projectList,
                  isDroppable: false,
                });
              }

              this.setState({
                isLoadingTree: false,
                isDroppable: true,
                projectList,
              }, () => {
                this.findSelectedRow({ projectIndex: findSelectedIndex, target: callback });
              });
            } else if (callback === 'search') {
              if (projectList.length === 0) {
                return this.setState({
                  isDroppable: false,
                  isLoadingTree: false,
                  projectList,
                });
              }
              const findSelectedIndex = projectList.findIndex((item) => {
                return item.data.selected === true;
              });
              if (findSelectedIndex === -1) {
                this.dropzoneMsg = translate('modal.new_scan.message.warn_project_verion');
                return this.setState({
                  isLoadingTree: false,
                  projectList,
                  isDroppable: false,
                });
              }
              return this.setState({
                isLoadingTree: false,
                isDroppable: true,
                projectList,
              }, () => {
                this.findSelectedRow({ projectIndex: findSelectedIndex, target: 'findSelectedRow' });
              });
            } else {
              this.dropzoneMsg = translate('modal.new_scan.message.warn_project_verion');
              this.setState({
                isLoadingTree: false,
                //totalCount: response.count,
                projectList,
                isDroppable: false,
              });
            }
          })
          .catch((err) => {
            console.log(err);
            this.setState({
              isLoadingTree: false,
            });
          });
      });
    }
  };

  getProjectVersionTree = (parentIndex, callback) => {
    const {
      projectList, parentId, searchKeyword, selectedVersion
    } = this.state;

    if (callback === 'createProject' || callback === 'addVersion') {
      api.getProjectVersionTree(
        {
          search: '',
          target_object: 'project_version',
          object_parent_id: parentId,
          page: 1,
        }
      )
        .then((response) => {
          const projectVersionList = response.response.map((item) => {
            return {
              data: item,
              children: [],
            };
          });

          if (callback === 'createProject') {
            this.search.value = '';
            this.setState({
              projectList: Update(projectList, {
                [parentIndex]: {
                  children: {
                    $push: projectVersionList,
                  },
                },
              }),
              searchKeyword: '',
            }, () => {
              this.findSelectedRow({ projectIndex: parentIndex, versionIndex: 0 });
            });
          } else if (callback === 'addVersion') {
            this.search.value = '';
            const selectedRow = projectVersionList.findIndex((item) => {
              return item.data.id === selectedVersion;
            });

            this.setState({
              projectList: Update(projectList, {
                [parentIndex]: {
                  children: {
                    $set: projectVersionList,
                  },
                },
              }),
              searchKeyword: '',
              isDroppable: true,
            }, () => {
              this.findSelectedRow({ projectIndex: parentIndex, versionIndex: selectedRow });
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isLoadingTree: false,
          });
        });
    } else {
      api.getProjectVersionTree(
        {
          search: searchKeyword,
          target_object: 'project_version',
          object_parent_id: parentId,
          page: 1,
        }
      )
        .then((response) => {
          const projectVersionList = response.response.map((item) => {
            return {
              data: item,
              children: [],
            };
          });

          if (callback === 'findSelectedRow') {
            const selectedRow = projectVersionList.findIndex((item) => {
              return item.data.selected === true;
            });

            if (selectedRow === -1) {
              this.setState({
                projectList: Update(projectList, {
                  [parentIndex]: {
                    children: {
                      $push: projectVersionList,
                    },
                  },
                }),
              });
            } else {
              this.setState({
                projectList: Update(projectList, {
                  [parentIndex]: {
                    children: {
                      $push: projectVersionList,
                    },
                  },
                }),
              }, () => {
                this.findSelectedRow({ projectIndex: parentIndex, versionIndex: selectedRow });
              });
            }
          } else {
            this.setState({
              projectList: Update(projectList, {
                [parentIndex]: {
                  children: {
                    $push: projectVersionList,
                  },
                },
              }),
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isLoadingTree: false,
          });
        });
    }
  };

  getScanList = () => {
    const obj = {
      page: 1,
      limit: '',
    };
    const { usertimeStamp } = this.state;
    const { translate } = this.props;

    this.setState({
      isLoading: true,
    }, () => {
      api
        .getScanList(obj)
        .then((response) => {
          const data = convertPropertiesToCamelCase(response.response);
          if (!data.licenseRegistered) {
            this.dropzoneMsg = translate('modal.new_scan.message.warn_register_company');
            return this.setState({
              licenseRegistered: data.licenseRegistered,
              isLoading: false,
              isDroppable: false,
            });
          }
          if (data.licenseRegistered && !data.licenseCurrent) {
            this.dropzoneMsg = translate('modal.new_scan.message.warn_expired_license');
            return this.setState({
              licenseRegistered: data.licenseRegistered,
              licenseCurrent: data.licenseCurrent,
              isLoading: false,
              isDroppable: false,
            });
          }

          if (data.remainDisk.warn_level === 'forbidden' && data.licenseRegistered && data.licenseCurrent) {
            this.dropzoneMsg = translate('modal.new_scan.message.warn_forbidden_disk_space');
            return this.setState({
              isLoading: false,
              isDroppable: false,
              licenseRegistered: data.licenseRegistered,
              licenseCurrent: data.licenseCurrent,
              warnLevel: data.remainDisk.warn_level,
            });
          }

          if (data.remainDisk.warn_level === 'warn' && data.licenseRegistered && data.licenseCurrent && this.timeExpired(usertimeStamp)) {
            localStorage.setItem('modal-timestamp', Date.now());
            this.modalBody = translate('modal.new_scan.message.warn_disk_space');
            this.setState({
              isOpenWarnDisk: true,
              usertimeStamp: Date.now(),
              warnLevel: data.remainDisk.warn_level,
            });
          }

          if (data.licenseRegistered && data.licenseCurrent && data.remainDisk.warn_level !== 'forbidden') {
            this.setState({
              isStartScan: true,
            });
          }

          this.setState({
            isLoading: false,
            licenseRegistered: data.licenseRegistered,
            licenseCurrent: data.licenseCurrent,
            isAllowShowQuota: data.quota.allow_show_quota,
            quotaResult: data.quota.quota_result,
            isUseScanOption: data.useScanOption,
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isLoading: false,
          });
        });
    });
  };

  getExtendToken = () => {
    api
      .getExtendToken()
      .then()
      .catch((err) => {
        console.log(err);
      });
  };

  handlOpenScanOption = () => {
    this.setState({
      isOpenScanOption: true,
      isLoadingScanOptionBtn: true,
    });
  };

  postReport = (fileData) => {
    const { state, translate } = this.props;
    const { selectedProjectNm, selectedVersionNm } = this.state;
    this.onUpdateTokenStart();
    const upLoaders = fileData.map((file) => {
      const fnUploadProgress = (myFileid) => {
        return (progressEvent) => {
          const percentage = Math.round((progressEvent.loaded / progressEvent.total) * 100);
          state.report.updateProgressArray(percentage, myFileid, 'local');
        };
      };

      const { CancelToken } = axios;
      const source = CancelToken.source();

      const newSource = {
        front_id: file.newData.front_id,
        source,
      };

      this.cancelToken.push(newSource);

      return (
        api
          .postReport(file.formData, fnUploadProgress(file.newData.front_id), source.token)
          .then((response) => {
            const data = response.response;
            const newData = {
              uploaded_file_id: data.uploaded_file_id,
              front_id: data.front_id,
              project_id: data.project_id,
              project_version_id: data.project_version_id,
              name: data.name,
              project_name: selectedProjectNm,
              project_version_name: selectedVersionNm,
              scan_status: data.scan_status,
              scan_status_detail: data.scan_status_detail,
              scan_progress: 0,
              uploaded_size: file.newData.uploaded_size,
              has_manage_permission: data.has_manage_permission,
            };

            const obj = {
              front_id: data.front_id,
              status: 'scanning',
            };

            state.report.addFrontId(data.front_id);
            state.report.updateProgressArray(100, file.newData.front_id, 'local');
            state.report.setScanning(obj);
            state.report.setReload();

            this.setState((prevState) => {
              const currentIndex = prevState.scanningStatus.findIndex((item) => {
                return item.front_id === file.newData.front_id;
              });

              if (currentIndex === -1) {
                return null;
              }

              const newStatusArray = Object.assign([...prevState.scanningStatus], { [currentIndex]: newData });
              return {
                scanningStatus: newStatusArray,
              };
            });
          })
          .catch((err) => {
            console.log(err);
            if (axios.isCancel(err)) {
              console.log('Request canceled', err.message);
            } else {
              const o = err?.data?.response;

              if (err.status === '413' || err.status === 413) {
                this.modalBody = err.statusText;
                this.stopFileUploading(file.newData.name, file.newData.front_id);

                this.setState((prevState) => {
                  const newStatusArray = prevState.scanningStatus.filter((item) => {
                    return item.front_id !== file.newData.front_id;
                  });
                  return {
                    modalWithError: true,
                    scanningStatus: newStatusArray,
                  };
                });

                state.report.updateProgressArray(0, file.newData.front_id, 'local');
                return;
              }

              if (!o || !o.error) {
                this.modalBody = translate('modal.new_scan.error.error_unknown');
              } else {
                switch (o.error) {
                case '422-653':
                  this.modalBody = translate('modal.new_scan.error.error_422_653');
                  break;
                case '422-366':
                  this.modalBody = o.error_description;
                  this.stopFileUploading(file.newData.name, file.newData.front_id);
                  break;
                case '500-366':
                  this.modalBody = o.error_description;
                  break;
                default:
                  this.modalBody = o.error_description || translate('modal.new_scan.error.error_unknown');
                  break;
                }
              }
            }

            this.setState((prevState) => {
              const newStatusArray = prevState.scanningStatus.filter((item) => { return item.front_id !== file.newData.front_id; });
              return {
                modalWithError: true,
                scanningStatus: newStatusArray,
              };
            });

            if (this.fileInputRef.current) {
              this.fileInputRef.current.value = '';
            }
            if (this.folderInputRef.current) {
              this.folderInputRef.current.value = '';
            }
            state.report.updateProgressArray(0, file.newData.front_id, 'local', 'error');
          })
      );
    });

    axios.all(upLoaders)
      .then(() => {
        this.onUpdateStart();
        if (this.fileInputRef.current) {
          this.fileInputRef.current.value = '';
        }
        if (this.folderInputRef.current) {
          this.folderInputRef.current.value = '';
        }
      })
      .catch((err) => {
        if (axios.isCancel(err)) {
          console.log('Request canceled', err.message);
        } else {
          // handle error
          console.log(err);
        }
      });
  };

  postReportWithUrl = (obj, url) => {
    this.onUpdateTokenStart();
    const {
      scanOptions,
      selectedProjectNm,
      selectedVersionNm
    } = this.state;
    const { state, translate } = this.props;
    let data;
    if (Object.keys(scanOptions).length !== 0) {
      data = {
        front_id: obj.front_id,
        url,
        selected_project_id: obj.project_id,
        selected_project_version_id: obj.project_version_id,
        scan_option: JSON.stringify(scanOptions),
      };
    } else {
      data = {
        front_id: obj.front_id,
        url,
        selected_project_id: obj.project_id,
        selected_project_version_id: obj.project_version_id,
      };
    }

    const { CancelToken } = axios;
    const source = CancelToken.source();

    const newSource = {
      front_id: obj.front_id,
      source,
    };

    this.cancelToken.push(newSource);

    this.onUpdateStart();

    api
      .postReportWithUrl(data)
      .then((res) => {
        const o = res.response;
        const newData = {
          uploaded_file_id: o.uploaded_file_id,
          front_id: o.front_id,
          project_id: o.project_id,
          project_version_id: o.project_version_id,
          name: o.name,
          project_name: selectedProjectNm,
          project_version_name: selectedVersionNm,
          scan_status: o.scan_status,
          scan_status_detail: o.scan_status_detail,
          scan_progress: 0,
          uploaded_size: o.uploaded_size,
          uploaded_progress: o.uploaded_progress,
          has_manage_permission: o.has_manage_permission,
        };

        const storeObject = {
          front_id: o.front_id,
          status: 'scanning',
        };

        state.report.addFrontId(data.front_id);
        state.report.updateProgressArray(100, data.front_id, 'url');
        state.report.setScanning(storeObject);
        state.report.setReload();

        this.setState((prevState) => {
          const currentIndex = prevState.scanningStatus.findIndex((item) => {
            return item.front_id === newData.front_id;
          });

          const newStatusArray = Object.assign([...prevState.scanningStatus], { [currentIndex]: newData });
          return {
            scanningStatus: newStatusArray,
            isUploadError: false,
            uploadErrorMsg: '',
          };
        });
      })
      .catch((err) => {
        console.log(err);

        const o = err?.data?.response;

        if (err.status === '413' || err.status === 413) {
          this.modalBody = err.statusText;
          this.stopFileUploading(obj.name, obj.front_id);

          this.setState((prevState) => {
            const newStatusArray = prevState.scanningStatus.filter((item) => {
              return item.front_id !== obj.front_id;
            });
            return {
              modalWithError: true,
              scanningStatus: newStatusArray,
            };
          });

          state.report.updateProgressArray(0, obj.front_id, 'local', 'error');
          return;
        }

        if (!o || !o.error) {
          this.modalBody = translate('modal.new_scan.error.error_unknown');
          this.stopFileUploading(obj.name, obj.front_id);
        } else {
          switch (o.error) {
          case '422-653':
            this.modalBody = translate('modal.new_scan.error.error_422_653');
            this.stopFileUploading(obj.name, obj.front_id);
            break;
          case '422-366':
            this.modalBody = o.error_description;
            this.stopFileUploading(obj.name, obj.front_id);
            break;
          case '500-366':
            this.modalBody = o.error_description;
            break;
          default:
            this.modalBody = o.error_description || translate('modal.new_scan.error.error_unknown');
            break;
          }
        }

        this.setState((prevState) => {
          const newStatusArray = prevState.scanningStatus.filter((item) => { return item.front_id !== obj.front_id; });
          return {
            modalWithError: true,
            isUploadError: true,
            scanningStatus: newStatusArray,
          };
        });

        state.report.updateProgressArray(0, obj.front_id, 'local', 'error');
      });
  };

  findSelectedRow = (obj) => {
    const { projectList, isStartScan } = this.state;
    const data = obj;

    if (data.target) {
      const parentId = projectList[data.projectIndex].data.target_id.project_id;
      return this.setState({
        activeIndex: [data.projectIndex],
        parentId,
      }, () => {
        this.getProjectVersionTree(data.projectIndex, data.target);
      });
    }

    if (isStartScan) {
      return this.setState({
        selectedIndex: `${data.projectIndex}-${data.versionIndex}`,
        selectedProject: projectList[data.projectIndex].data.target_id.project_id,
        selectedProjectNm: projectList[data.projectIndex].data.name,
        selectedVersion: projectList[data.projectIndex].children[data.versionIndex].data.target_id.project_version_id,
        selectedVersionNm: projectList[data.projectIndex].children[data.versionIndex].data.name,
      });
    }
    return this.setState({
      isDroppable: false,
      selectedIndex: `${data.projectIndex}-${data.versionIndex}`,
      selectedProject: projectList[data.projectIndex].data.target_id.project_id,
      selectedProjectNm: projectList[data.projectIndex].data.name,
      selectedVersion: projectList[data.projectIndex].children[data.versionIndex].data.target_id.project_version_id,
      selectedVersionNm: projectList[data.projectIndex].children[data.versionIndex].data.name,
    });
  };

  timeExpired = (timestamp) => {
    if (!timestamp || Date.now() - timestamp > WAIT) {
      return true;
    }
  };

  toggleRow = (index, targetId) => {
    const { activeIndex, projectList, selectedIndex } = this.state;
    let newState;

    if (activeIndex.indexOf(index) > -1) {
      newState = activeIndex.filter((i) => {
        return i !== index;
      });

      if (typeof selectedIndex === 'number' && Number(selectedIndex) === index) {
        this.setState({
          selectedIndex: '',
          selectedProject: '',
          selectedProjectNm: '',
        });
      } else if (typeof selectedIndex === 'string') {
        const stringValue = selectedIndex.split('-');
        if (Number(stringValue[0]) === index) {
          this.setState({
            selectedIndex: '',
            selectedProject: '',
            selectedProjectNm: '',
            selectedVersion: '',
            selectedVersionNm: '',
          });
        }
      }

      this.setState({
        projectList: Update(projectList, {
          [index]: {
            children: {
              $set: [],
            },
          },
        },),
        activeIndex: newState,
      });
    } else {
      newState = [...activeIndex, index];
      this.setState({
        activeIndex: newState,
        parentId: targetId,
      }, () => {
        this.getProjectVersionTree(index);
      });
    }

  };

  handleOpenUrlUpload = () => {
    this.setState({
      isShowURL: true,
      fileURL: '',
      uploadErrorMsg: '',
      isUploadError: false,
    });
  };

  handleCloseUrlUpload = () => {
    this.setState({
      isShowURL: false,
      uploadErrorMsg: '',
      isUploadError: false,
    });
  };

  handlUrlUploadChange = (e) => {
    const { translate } = this.props;
    const { value } = e.target;
    if (e.key === 'Enter') {
      if (value === '' || value === null || value === undefined) {
        return this.setState({
          uploadErrorMsg: translate('modal.new_scan.error.error_enter_url'),
          isUploadError: true,
        });
      }

      if (!this.validURL(value)) {
        return this.setState({
          uploadErrorMsg: translate('modal.new_scan.error.error_valid_url'),
          isUploadError: true,
        });
      }

      return this.setState({
        uploadErrorMsg: '',
        isUploadError: false,
        isShowURL: false,
      }, () => {
        this.onDropWithUrl(value);
      });
    }
  };

  handleUrlChange = (e) => {
    this.setState({
      fileURL: e.target.value,
    });
  };

  handleFileUploadClick = () => {
    if (this.fileInputRef.current) {
      this.fileInputRef.current.click();
    }
  };

  handleFolderUploadClick = () => {
    if (this.folderInputRef.current) {
      this.folderInputRef.current.click();
    }
  };

  handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    this.onDrop(files);
  };

  handleFolderChange = (event) => {
    const files = Array.from(event.target.files);
    this.onDropFolder(files);

    event.target.value = null;
  };

  handleDirectory = async (directoryEntry, files, path = '') => {
    const reader = directoryEntry.createReader();
    const entries = [];

    const readAllEntries = async () => {
      return new Promise((resolve, reject) => {
        const read = () => {
          reader.readEntries(async (results) => {
            if (!results.length) return resolve(entries);
            entries.push(...results);
            read();
          }, reject);
        };
        read();
      });
    };

    await readAllEntries();

    if (entries.length === 0) {
      files.push({
        isDirectory: true,
        relativePath: path,
      });
    }

    const promises = entries.map(async (entry) => {
      if (entry.isDirectory) {
        await this.handleDirectory(entry, files, `${path}${entry.name}/`);
      } else {
        await new Promise((resolve) => {
          entry.file((file) => {
            const customFile = new File([file], file.name, {
              type: file.type,
              lastModified: file.lastModified,
            });

            Object.defineProperty(customFile, 'webkitRelativePath', {
              value: `${path}${file.name}`,
            });

            files.push(customFile);
            resolve();
          });
        });
      }
    });

    await Promise.all(promises);
  };

  handleDrop = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    const { items } = event.dataTransfer;
    const folders = {};
    const files = [];

    const processFile = async (item) => {
      if (item.kind === 'file') {
        const entry = item.webkitGetAsEntry();
        if (entry.isDirectory) {
          const folderName = entry.name;
          if (!folders[folderName]) {
            folders[folderName] = [];
          }
          await this.handleDirectory(entry, folders[folderName]);
        } else if (entry.isFile) {
          await new Promise((resolve, reject) => {
            entry.file((file) => {
              files.push(file);
              resolve();
            }, reject);
          });
        } else {
          await new Promise((resolve) => {
            item.getAsFile((file) => {
              const pathParts = file.webkitRelativePath.split('/');
              const folderName = pathParts.length > 1 ? pathParts[0] : 'Uploaded_Files';
              if (!folders[folderName]) {
                folders[folderName] = [];
              }
              folders[folderName].push(file);
              resolve();
            });
          });
        }
      }
    };

    const promises = Array.from(items).map((item) => { return processFile(item); });
    await Promise.all(promises);

    if (files.length > 0) {
      await this.onDrop(files, 'drop');
    }

    if (Object.keys(folders).length > 0) {
      this.onDropFolder(folders, 'drop');
    }
  };

  stopFileUploading = (name, id) => {
    const { scanningStatus } = this.state;
    const { state } = this.props;
    const selectedArray = this.cancelToken.filter((item) => {
      return item.front_id === id;
    });

    const newState = scanningStatus.filter((item) => {
      return item.front_id !== id;
    });

    const obj = {
      front_id: id,
      status: 'uploading',
    };

    selectedArray[0].source.cancel();
    state.report.removeScanning(obj);

    this.setState({
      scanningStatus: newState,
    });
  };

  createProject = () => {
    this.setState({
      isOpenMCP: true,
    });
  };

  addVersion = (e, projectIndex) => {
    const { projectList } = this.state;

    this.setState({
      isOpenMAV: true,
      targetName: projectList[projectIndex].data.name,
      targetId: projectList[projectIndex].data.target_id.project_id,
    });
  };

  deleteCallback = (data) => {
    const { scanningStatus } = this.state;
    const { state } = this.props;
    const frontId = data.front_id;
    const newData = scanningStatus.filter((item) => {
      return item.front_id !== frontId;
    });

    const obj = {
      front_id: frontId,
    };

    state.report.removeScanning(obj);
    this.setState({
      scanningStatus: newData,
    });
  };

  upLoadFileFromUrl = () => {
    const { translate } = this.props;
    const { fileURL } = this.state;
    if (fileURL === '' || fileURL === null || fileURL === undefined) {
      return this.setState({
        uploadErrorMsg: translate('modal.new_scan.error.error_enter_url'),
        isUploadError: true,
      });
    }
    if (!this.validURL(fileURL)) {
      return this.setState({
        uploadErrorMsg: translate('modal.new_scan.error.error_valid_url'),
        isUploadError: true,
      });
    }
    return this.setState({
      uploadErrorMsg: '',
      isUploadError: false,
      isShowURL: false,
    }, () => {
      this.onDropWithUrl(fileURL);
    });
  };

  addToFolderToZip = async (targetFolder, newData) => {
    const { state, translate } = this.props;
    const zip = new JSZip();

    const addFileToZip = (file) => {
      return new Promise((resolve, reject) => {
        if (file.isDirectory) {
          zip.folder(file.relativePath);
          resolve();
          return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
          const relativePath = file.webkitRelativePath || file.name;
          zip.file(relativePath, e.target.result);
          resolve();
        };
        reader.onerror = reject;
        reader.readAsArrayBuffer(file);
      });
    };

    try {
      const tasks = targetFolder.map(addFileToZip);
      await Promise.all(tasks);

      const content = await zip.generateAsync(
        { type: 'blob' },
        (metadata) => {
          const percentage = Math.round((metadata.percent / 100) * 100);
          state.report.updateProgressArray(percentage, newData.front_id, 'folder');
        }
      );

      const namedBlob = new File([content], newData.name, { type: 'application/zip' });
      return { namedBlob, size: content.size };
    } catch (err) {
      const error = err.target.error;

      if (!error) {
        this.modalBody = translate('modal.message.compression_failed', { folderName: newData.name });
        this.setState({
          modalWithError: true,
        });
        return;
      }

      if (error instanceof DOMException && error.name === 'QuotaExceededError') {
        this.modalBody = translate('modal.message.disk_space_exceeded', { folderName: newData.name });
        this.setState({
          modalWithError: true,
        });
      } else if (error instanceof DOMException && error.name === 'NotReadableError') {
        this.modalBody = translate('modal.message.file_not_readable', { folderName: newData.name });
        this.setState({
          modalWithError: true,
        });

      } else {
        this.modalBody = translate('modal.message.compression_failed', { folderName: newData.name });
        this.setState({
          modalWithError: true,
        });
      }
      state.report.updateProgressArray(0, newData.front_id, 'folder', 'error');
      throw error;
    }
  };

  clearSearch = () => {
    this.search.value = '';
    this.setState(
      {
        searchKeyword: '',
        projectList: [],
        activeIndex: [],
        selectedIndex: [],
      },
      () => {
        this.getProjectTree('findSelectedRow');
      }
    );
  };

  closeScanOption = () => {
    this.setState({
      isLoadingScanOptionBtn: false,
      isOpenScanOption: false,
    });
  };

  applyScanOption = (obj, bak) => {
    this.setState({
      scanOptions: obj,
      scanOptionsWithGUI: bak,
      isLoadingScanOptionBtn: false,
      isOpenScanOption: false,
      isUseScanOption: true,
    });
  };

  initUploadingList = () => {
    const { scanningStatus } = this.state;
    const { state, closeModal, translate } = this.props;

    this.setState({
      isWarnModalLoader: true,
      isWarModalError: false,
    });

    const removeUrlArray = scanningStatus.filter((item) => {
      return !item.type && item.scan_status === 5;
    });

    const removeLocalArray = scanningStatus.filter((item) => {
      return item.scan_status_detail === 'Uploading' || item.scan_status === 6;
    });

    if (removeUrlArray.length !== 0) {
      const urlIds = removeUrlArray.map((item) => {
        return item.front_id;
      });

      urlIds.map(async (item) => {
        const obj = {
          front_id: item,
        };

        const removedObject = await api
          .newScanDelete(obj)
          .then(() => {
            const storeObject = {
              front_id: item,
            };
            state.report.removeScanning(storeObject);
          })
          .catch((err) => {
            console.log(err);
            const o = err.data.response;

            this.modalBody = translate('modal.title.attention');

            if (o.error === '422-206') {
              this.smallBody = translate('modal.new_scan.error.error_422_206');
            }

            if (o.error === '422-021') {
              this.smallBody = translate('modal.new_scan.error.error_422_021');
            }

            if (o.error === '422-366') {
              this.smallBody = o.error_description;
            }

            this.setState({
              isWarModalError: true,
              isWarnModalLoader: false,
            });
          });

        return removedObject;
      });
    }

    if (removeLocalArray.length !== 0) {
      const localIds = removeLocalArray.map((item) => {
        return item.front_id;
      });

      localIds.map(async (item) => {
        const stopFileObject = await this.stopFileUploading('name', item);
        return stopFileObject;
      });
    }

    this.setState({
      isOpenWarnModal: false,
      isWarnModalLoader: false,
      isWarModalError: false,
    }, () => {
      state.report.syncNewScanModal(false);
      closeModal();
    });
  };

  validateQuota = (data) => {
    const { translate } = this.props;
    const {
      usertimeStamp,
      licenseRegistered,
      licenseCurrent,
      remainDisk,
    } = data;

    if (!licenseRegistered && !licenseCurrent) {
      this.dropzoneMsg = translate('modal.new_scan.message.warn_register_company');
      this.setState({
        isDroppable: false,
        licenseRegistered,
        licenseCurrent,
        isStartScan: false,
      });
      return false;
    }

    if (!licenseRegistered && licenseCurrent) {
      this.dropzoneMsg = translate('modal.new_scan.message.warn_register_company');
      this.setState({
        isDroppable: false,
        licenseRegistered,
        licenseCurrent,
        isStartScan: false,
      });
      return false;
    }

    if (licenseRegistered && !licenseCurrent) {
      this.dropzoneMsg = translate('modal.new_scan.message.warn_expired_license');
      this.setState({
        isDroppable: false,
        licenseRegistered,
        licenseCurrent,
        isStartScan: false,
      });
      return false;
    }

    if (remainDisk.warn_level === 'forbidden' && licenseRegistered && licenseCurrent) {
      this.dropzoneMsg = translate('modal.new_scan.message.warn_forbidden_disk_space');
      this.setState({
        isDroppable: false,
        warnLevel: remainDisk.warn_level,
        licenseRegistered,
        licenseCurrent,
        isStartScan: false,
      });
      return false;
    }

    if (remainDisk.warn_level === 'warn' && licenseRegistered && licenseCurrent && this.timeExpired(usertimeStamp)) {
      localStorage.setItem('modal-timestamp', Date.now());
      this.modalBody = translate('modal.new_scan.message.warn_disk_space');
      this.setState({
        isOpenWarnDisk: true,
        warnLevel: remainDisk.warn_level,
        //usertimeStamp: Date.now(),
        licenseRegistered,
        licenseCurrent,
      });
      return true;
    }
    return true;
  };

  validURL = (str) => {
    const pattern = new RegExp('^(https?:\\/\\/)?' // protocol
    + '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' // domain name
    + '((\\d{1,3}\\.){3}\\d{1,3}))' // OR ip (v4) address
    + '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' // port and path
    + '(\\?[;&a-z\\d%_.~+=-]*)?' // query string
    + '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
    return !!pattern.test(str);
  };

  isAlreadyExisted = (projectNm) => {
    let result = false;
    const { projectList } = this.state;
    const existData = projectList.filter((item) => {
      return item.data.name === projectNm;
    });

    if (existData.length !== 0) {
      result = true;
    }
    return result;
  };

  closeNewScanModal = (e) => {
    const {
      state,
      closeModal,
    } = this.props;

    if (e.target.classList[0] === 'cancel' || e.target.classList[0] === 'upload') {
      return;
    }
    state.report.syncNewScanModal(false);
    closeModal();
  };

  closeDiskModal = () => {
    this.setState({
      isOpenWarnDisk: false,
    });
  };

  closeErrorModal = () => {
    this.setState({
      modalWithError: false,
    });
  };

  closeWarnModal = () => {
    this.setState({
      isOpenWarnModal: false,
    });
  };

  byteToSize = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return `${parseFloat((bytes / (k ** i)).toFixed(dm))} ${sizes[i]}`;
  };

  validateForm = () => {
    const {
      selectedProjectNm,
      selectedVersionNm,
    } = this.state;

    const validation = {
      isSelectProject: true,
      isSelectVersion: true,
    };

    if (selectedProjectNm.trim().length === 0) {
      validation.isSelectProject = false;
      return;
    }
    validation.isSelectProject = true;

    if (selectedVersionNm.trim().length === 0) {
      validation.isSelectVersion = false;
      return;
    }
    validation.isSelectVersion = true;

    return (
      validation.isSelectProject
      && validation.isSelectVersion
    );
  };

  render() {
    const {
      activeIndex,
      selectedIndex,
      isAllowShowQuota,
      quotaResult,
      selectedProjectNm,
      selectedVersionNm,
      projectList,
      selectedColumn,
      scanningStatus,
      isLoading,
      isLoadingTree,
      errSearch,
      licenseRegistered,
      licenseCurrent,
      warnLevel,
      isDroppable,
      isUseScanOption,
      isOpenScanOption,
      isLoadingScanOptionBtn,
      isOpenScan,
      isShowURL,
      isUploadError,
      fileURL,
      uploadErrorMsg,
      isUrlLoading,
      isOpenMCP,
      isOpenMAV,
      targetId,
      targetName,
      isOpenWarnDisk,
      modalWithError,
      isOpenWarnModal,
      isWarnModalLoader,
      isWarModalError,
      scanOptionsWithGUI,
    } = this.state;

    const { translate } = this.props;

    const sortColumn = [
      { key: 1, text: translate('modal.new_scan.title.newest'), value: 'uploaded' },
      { key: 2, text: translate('modal.new_scan.title.atoz'), value: 'project_r' },
      { key: 3, text: translate('modal.new_scan.title.ztoa'), value: 'project' },
    ];

    return (
      <Modal open={isOpenScan} onClose={this.closeNewScanModal}>
        <div className="new_scan_popup_wrap hide custom_new_scan show">
          <div className="new_scan_popup full_parts">
            <div className="popup_header ">
              <div className="popup_wrap">
                <span className="popup_title">{translate('modal.new_scan.title.new_scan')}</span>
                <div className="util_wrap">
                  <div className="util_item">
                    <div className="button_wrap">
                      {
                        isLoadingScanOptionBtn ? (
                          <a
                            className="button option"
                            style={{ pointerEvents: 'none' }}
                          >
                            {translate('modal.new_scan.title.open_scan_option')}
                          </a>
                        ) : (
                          <a
                            className="button option"
                            onClick={this.handlOpenScanOption}
                            onKeyUp={this.handlOpenScanOption}
                          >
                            {translate('modal.new_scan.title.open_scan_option')}
                          </a>
                        )
                      }
                    </div>
                  </div>
                </div>
                <a
                  className="close_button"
                  onClick={this.closeNewScanModal}
                  onKeyUp={this.closeNewScanModal}
                >
                  <img src={closeBtn} alt="" />
                </a>
              </div>
              <Message
                info
                size="tiny"
              >
                <Message.Header>
                  {
                    isUseScanOption ? translate('modal.new_scan.message.scan_option_on') : translate('modal.new_scan.message.scan_option_off')
                  }
                </Message.Header>
                <p>{translate('modal.new_scan.message.warn_scan_guide')}</p>
              </Message>
            </div>
            {
              !isLoading ? (
                <div className="popup_contents">
                  <div className="popup_contnet_left_menu">
                    <div className="projects_list_wrap">
                      <div className="projects_search_wrap">
                        <img src={search} alt="" className="search_icon" />
                        <input
                          ref={(ref) => {
                            this.search = ref;
                          }}
                          type="text"
                          className="projects_search"
                          placeholder={translate('modal.new_scan.place_holder.search')}
                          onKeyPress={this.handleSearch}
                          style={{ width: '170px' }}
                        />
                        <a
                          className="reset_icon"
                          onClick={this.clearSearch}
                          onKeyUp={this.clearSearch}
                        >
                          x
                        </a>
                        {errSearch && (
                          <Label basic color="red" pointing>
                            {translate('modal.new_scan.message.least_two_required_to_search')}
                          </Label>
                        )}
                      </div>
                      <div className="projects_list">
                        {
                          !isLoadingTree ? (
                            <Scrollbars
                              renderTrackHorizontal={() => {
                                return <div />;
                              }}
                              renderThumbHorizontal={() => {
                                return <div />;
                              }}
                            >
                              <ul className="depth_1">
                                <li>
                                  {
                                    !licenseRegistered || !licenseCurrent || warnLevel === 'forbidden' ? (
                                      <a className="create disabled">
                                        <p>
                                          <Icon name="add" />
                                          <span>
                                            [
                                            {translate('modal.new_scan.title.new_project')}
                                            ]
                                          </span>
                                        </p>
                                      </a>
                                    ) : (
                                      <a
                                        className="create"
                                        onClick={this.createProject}
                                        onKeyUp={this.createProject}
                                      >
                                        <p>
                                          <Icon name="add" />
                                          <span>
                                            [
                                            {translate('modal.new_scan.title.new_project')}
                                            ]
                                          </span>
                                        </p>
                                      </a>
                                    )
                                  }
                                </li>
                                {
                                  projectList.length !== 0
                                  && projectList.map((project, projectIndex) => {
                                    return (
                                      <li
                                        key={project.data.id.toString()}
                                        className={cx({
                                          expand: activeIndex.indexOf(projectIndex) > -1,
                                        })}
                                      >
                                        <a>
                                          <span
                                            style={{ cursor: 'pointer', margin: '0' }}
                                            onClick={() => {
                                              return this.toggleRow(projectIndex, project.data.target_id.project_id);
                                            }}
                                            onKeyUp={() => {
                                              return this.toggleRow(projectIndex, project.data.target_id.project_id);
                                            }}
                                          >
                                            <img className="fold_icon" src={foldImg} role="presentation" alt="" />
                                            <img
                                              className="expand_icon"
                                              src={expandImg}
                                              role="presentation"
                                              alt=""
                                            />
                                          </span>
                                          <span>
                                            {project.data.name}
                                          </span>
                                          {
                                            this.onUpdateActiveProject('project', project)
                                          }
                                        </a>
                                        <ul className="depth_2">
                                          {project.children.length !== 0
                                            && project.children.map((projectVersion, versionIndex) => {
                                              return (
                                                <li
                                                  key={projectVersion.data.id.toString()}
                                                >
                                                  <a
                                                    className={cx({
                                                      selected:
                                                        selectedIndex === `${projectIndex}-${versionIndex}`,
                                                    })}
                                                    onClick={(e) => {
                                                      return this.handleToggle(e, `${projectIndex}-${versionIndex}`);
                                                    }}
                                                    onKeyUp={(e) => {
                                                      return this.handleToggle(e, `${projectIndex}-${versionIndex}`);
                                                    }}
                                                  >
                                                    <p
                                                      style={{ margin: '0' }}
                                                    >
                                                      <img src={bulletImg} role="presentation" alt="" />
                                                    </p>
                                                    <span>
                                                      {projectVersion.data.name}
                                                    </span>
                                                    {
                                                      this.onUpdateActiveProject('version', project, projectVersion)
                                                    }
                                                  </a>
                                                </li>
                                              );
                                            })}
                                          <li>
                                            <a
                                              className="create"
                                              onClick={(e) => {
                                                return this.addVersion(e, projectIndex);
                                              }}
                                              onKeyUp={(e) => {
                                                return this.addVersion(e, projectIndex);
                                              }}
                                            >
                                              <p>
                                                <Icon name="add" />
                                                <span>
                                                  [
                                                  {translate('modal.new_scan.title.new_version')}
                                                  ]
                                                </span>
                                              </p>
                                            </a>
                                          </li>
                                        </ul>
                                      </li>
                                    );
                                  })
                                }
                              </ul>
                            </Scrollbars>
                          ) : (
                            <Loader active={isLoadingTree} inline="centered" />
                          )
                        }
                      </div>
                      <div className="newest">
                        <Dropdown
                          selection
                          options={sortColumn}
                          value={selectedColumn}
                          //disabled={!isDroppable}
                          onChange={this.handleSortingChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="popup_contnet_right">
                    <div className="drop_files_wrap">
                      {
                        isAllowShowQuota
                        && quotaResult.length !== 0
                        && quotaResult.map((item) => {
                          return (
                            <div key={item.type} className="popup_contnet_header cap">
                              <em className="unit">
                                {item.type === 'daily' ? translate('modal.new_scan.title.today_used') : translate('modal.new_scan.title.total_used') }
                                {' '}
                                {this.byteToSize(item.spent)}
                                {' '}
                                /
                                {' '}
                                {item.capacity === -1 ? translate('modal.new_scan.title.unlimited') : this.byteToSize(item.capacity)}
                              </em>
                            </div>
                          );
                        })
                      }

                      <div className="drop_files">
                        <div className="drop_files_wrap">
                          <div className="left">
                            <p className="file_info">
                              <TextWithEllipsis
                                className={cx({ error: !selectedProjectNm })}
                                text={!selectedProjectNm ? null : selectedProjectNm}
                                as="span"
                              />
                              {!selectedProjectNm ? null : '/'}
                              <TextWithEllipsis
                                className={cx({ error: !selectedVersionNm })}
                                text={!selectedVersionNm ? null : selectedVersionNm}
                                as="span"
                              />
                            </p>
                          </div>
                          <div className="right">
                            <div className="upload_button_wrap">
                              <a
                                className="button upload"
                                disabled={!isDroppable || !selectedProjectNm || !selectedVersionNm}
                                onClick={this.handleFileUploadClick}
                                onKeyUp={this.handleFileUploadClick}
                              >
                                <Icon name="file" />
                                {translate('modal.new_scan.title.file_type')}
                              </a>
                              <a
                                className="button upload"
                                disabled={!isDroppable || !selectedProjectNm || !selectedVersionNm}
                                onClick={this.handleFolderUploadClick}
                                onKeyUp={this.handleFolderUploadClick}
                              >
                                <Icon name="folder" />
                                {translate('modal.new_scan.title.folder_type')}
                              </a>
                            </div>
                          </div>
                        </div>
                        {
                          isDroppable ? (
                            <div
                              className="drop_files_here"
                              onDrop={this.handleDrop}
                              onDragOver={(event) => { return event.preventDefault(); }}
                            >
                              <Icon name="cloud upload" size="huge" />
                              <p>{translate('modal.new_scan.message.drag_drop_guide')}</p>
                            </div>
                          ) : (
                            <div
                              className="drop_files_here disable"
                            >
                              <Icon name="ban" size="huge" />
                              <p>{this.dropzoneMsg}</p>
                            </div>
                          )
                        }
                        <input
                          type="file"
                          ref={this.fileInputRef}
                          style={{ display: 'none' }}
                          onChange={this.handleFileChange}
                          multiple
                        />
                        <input
                          type="file"
                          ref={this.folderInputRef}
                          style={{ display: 'none' }}
                          onChange={this.handleFolderChange}
                          webkitdirectory="true"
                          multiple
                        />
                        <div className="button_wrap">
                          <Popup
                            trigger={(
                              <a
                                className="url_button"
                              >
                                URL
                              </a>
                            )}
                            className="url_popup"
                            on="click"
                            position="bottom right"
                            onClose={this.handleCloseUrlUpload}
                            onOpen={this.handleOpenUrlUpload}
                            open={isShowURL}
                          >
                            <div
                              className={cx(
                                'input_wrap',
                                {
                                  error: isUploadError,
                                }
                              )}
                            >
                              <input
                                type="text"
                                placeholder={translate('modal.new_scan.place_holder.paste_url_here')}
                                value={fileURL}
                                onChange={this.handleUrlChange}
                                onKeyPress={this.handlUrlUploadChange}
                              />
                            </div>
                            {
                              isUploadError ? (
                                <div className="error">
                                  {uploadErrorMsg}
                                </div>
                              ) : null
                            }
                            {
                              isUrlLoading ? (
                                <div className="url_popup_bottom">
                                  <img
                                    src={progress}
                                    role="presentation"
                                    alt=""
                                    style={{
                                      width: 14,
                                      height: 14,
                                      margin: '5px 0 0 15px',
                                    }}
                                  />
                                </div>
                              ) : (
                                <div className="url_popup_bottom">
                                  <a
                                    className="cancel"
                                    onClick={this.handleCloseUrlUpload}
                                    onKeyUp={this.handleCloseUrlUpload}
                                  >
                                    {translate('modal.button.cancel')}

                                  </a>
                                  {
                                    !isDroppable || !selectedProjectNm || !selectedVersionNm ? (
                                      <a
                                        className="upload"
                                        style={{ pointerEvents: 'none', opacity: '0.3' }}
                                      >
                                        {translate('modal.button.upload')}
                                      </a>
                                    ) : (
                                      <a
                                        className="upload"
                                        onClick={this.upLoadFileFromUrl}
                                        onKeyUp={this.upLoadFileFromUrl}
                                      >
                                        {translate('modal.button.upload')}
                                      </a>
                                    )
                                  }
                                </div>
                              )
                            }
                          </Popup>
                        </div>
                      </div>
                    </div>
                    <div className="scanning_files_wrap">
                      <div className="popup_contnet_header">
                        <h3>
                          {translate('modal.new_scan.title.scanning_files')}
                          (
                          {scanningStatus.length}
                          )
                        </h3>
                      </div>
                      <div className="scanning_files">
                        <div className="scanning_files_header">
                          <div className="scope_name" style={{ width: '60%' }}>{translate('list.title.file_name')}</div>
                          <div className="scope_name" style={{ width: '40%' }}>{translate('modal.title.status')}</div>
                        </div>
                        <div className="scanning_files_contnet">
                          <Scrollbars
                            renderTrackHorizontal={() => {
                              return <div />;
                            }}
                            renderThumbHorizontal={() => {
                              return <div />;
                            }}
                            autoHeight
                            autoHeightMax={265}
                          >
                            <table>
                              <tbody>
                                <tr>
                                  <td>
                                    {
                                      scanningStatus.length !== 0 ? (
                                        scanningStatus.map((item) => {
                                          return (
                                            <ScanningFile
                                              key={item.front_id}
                                              file={item}
                                              deleteCallback={this.deleteCallback}
                                              stopFileUploading={this.stopFileUploading}
                                              url={fileURL}
                                              translate={translate}
                                            />
                                          );
                                        })
                                      ) : null
                                    }
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </Scrollbars>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <ClarLoader />
              )
            }
          </div>
        </div>
        <CreateProjectModal
          isOpenMCP={isOpenMCP}
          closeModal={this.handleMCPClose}
          createCallback={this.handleCreateCallback}
          isAlreadyExisted={this.isAlreadyExisted}
          translate={translate}
        />
        <AddVersionModal
          isOpenMAV={isOpenMAV}
          closeModal={this.handleMAVClose}
          addCallback={this.handleAddCallback}
          projectId={targetId}
          projectNm={targetName}
          translate={translate}
        />
        <ScanOptionModal
          isOpenMSO={isOpenScanOption}
          defaultScanOptions={scanOptionsWithGUI}
          applyScanOption={this.applyScanOption}
          closeModal={this.closeScanOption}
        />
        <Modal
          className="modal"
          open={isOpenWarnDisk}
          onClose={this.closeDiskModal}
        >
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup confirm">
                <h2 className="title">{translate('modal.title.attention')}</h2>
                <Scrollbars
                  style={{ height: '200px' }}
                  renderTrackHorizontal={() => {
                    return <div />;
                  }}
                  renderThumbHorizontal={() => {
                    return <div />;
                  }}
                >
                  <p className="text">{this.modalBody}</p>
                </Scrollbars>
                <div className="button_wrap">
                  <a
                    className="center_button"
                    onClick={this.closeDiskModal}
                    onKeyUp={this.closeDiskModal}
                  >
                    {translate('modal.button.close')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          open={modalWithError}
          onClose={this.closeErrorModal}
          className="modal"
        >
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup confirm">
                <h2 className="title">{translate('modal.title.notice')}</h2>
                <Scrollbars
                  style={{ height: '200px' }}
                  renderTrackHorizontal={() => {
                    return <div />;
                  }}
                  renderThumbHorizontal={() => {
                    return <div />;
                  }}
                >
                  <p className="text">{this.modalBody}</p>
                </Scrollbars>
                <div className="button_wrap">
                  <a
                    className="center_button"
                    onClick={this.closeErrorModal}
                    onKeyUp={this.closeErrorModal}
                  >
                    {translate('modal.button.close')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          open={isOpenWarnModal}
          onClose={this.closeWarnModal}
          className="modal"
        >
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              {
                isWarnModalLoader ? (
                  <ClarLoader />
                ) : (
                  <div className="modal_popup confirm">
                    <h2 className="title">{translate('modal.title.attention')}</h2>
                    <p className="text">{this.modalBody}</p>
                    <p className="small_text">{this.smallBody}</p>
                    {
                      isWarModalError ? (
                        <div className="button_wrap">
                          <a
                            className="center_button"
                            onClick={this.closeWarnModal}
                            onKeyUp={this.closeWarnModal}
                          >
                            {translate('modal.button.close')}
                          </a>
                        </div>
                      ) : (
                        <div className="button_wrap">
                          <a
                            className="left_button"
                            onClick={this.closeWarnModal}
                            onKeyUp={this.closeWarnModal}
                          >
                            {translate('modal.button.cancel')}
                          </a>
                          <a
                            className="right_button"
                            onClick={this.initUploadingList}
                            onKeyUp={this.initUploadingList}
                          >
                            {translate('modal.button.ok')}
                          </a>
                        </div>
                      )
                    }
                  </div>
                )
              }
            </div>
          </div>
        </Modal>
      </Modal>
    );
  }
}

export default WithRouter(inject('state')(observer(NewScanModal)));
